import Count from 'core/modules/atoms/Count';
import PropTypes from 'prop-types';
import React from 'react';
import MaterialPreviewAssignedUsers from './MaterialPreviewAssignedUsers';
import useMaterialPreviewAssigned from './useMaterialPreviewAssigned';

function MaterialPreviewAssigned({ material, t }) {
  const { isQuizTask, isInProgress, isConsumed, isVideoLesson, turnedIt, graded, consumed, notConsumed } = useMaterialPreviewAssigned({
    material,
  });

  return (
    <div className="material-preview-assigned">
      <div>
        <Count number={<MaterialPreviewAssignedUsers allStudents={material?.assignedUsers} />} text={t('lesson:Assigned')} />
      </div>

      {isQuizTask && (
        <>
          <Count number={turnedIt} text={t('lesson:Turned it')} />
          <Count number={graded} text={t('lesson:Graded')} />
        </>
      )}

      {isConsumed && (
        <>
          <Count number={notConsumed} text={t('lesson:Not consumed')} />
          <Count number={consumed} text={t('lesson:Consumed')} />
        </>
      )}

      {isInProgress && (
        <>
          <Count number={material.item_jobs_total || 0} text={t('lesson:In progress')} />
          <Count number={material.item_jobs_completed || 0} text={t('lesson:Filled')} />
        </>
      )}

      {isVideoLesson && (
        <>
          <Count number={material.item_jobs_total || 0} text={t('lesson:Unfinished')} />
          <Count number={material.item_jobs_completed || 0} text={t('lesson:Completed')} />
        </>
      )}
    </div>
  );
}

MaterialPreviewAssigned.propTypes = {
  material: PropTypes.object,
  t: PropTypes.func,
};

export default MaterialPreviewAssigned;
